// src/lib/cookie.js
export function getCookie(name) {
  const cookies = document.cookie ? document.cookie.split(/; */) : [];
  const prefix = name + "=";
  for (const c of cookies) {
    if (c.startsWith(prefix)) {
      return c.slice(prefix.length); // return full value (don't decode)
    }
  }
  return undefined;
}
